import LinkWrapper from '@/components/LinkWrapper';
import Logo from '@/components/Logo';
import { LogoVariant } from '@/components/LogoVariant';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer className="Footer" id="footer">
      <div className="Footer__wrapper">
        {/* Footer Section Top */}
        <section className="Footer__section Footer__section--top">
          <h2 className="visually-hidden">Weiterführende Links</h2>
          <div className="Footer__topColumn">
            <div className="Footer__titleWrapper">
              <h3 className="Footer__title">Responsible Gaming</h3>
            </div>
            <div className="Footer__box">
              <div className="Footer__text--small">
                Erlaubt gemäß{' '}
                <a
                  href="https://www.gluecksspiel-behoerde.de/de/fuer-spielende/uebersicht-erlaubter-anbieter-whitelist"
                  className="Footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Externer Link: White-List der Glücksspielbehoerde (öffnet neues Fenster)"
                >
                  White-List
                </a>
                .{' '}
              </div>
              <div className="Footer__infoContainer Footer__infoContainer--logos">
                <div>
                  <a
                    href="https://www.european-lotteries.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Externer Link: The European Lotteries (öffnet neues Fenster)"
                  >
                    <Image
                      alt="The European Lotteries Logo"
                      src="/assets/images/logo-the-european-lotteries--white.svg"
                      className="Footer__image"
                      loading="lazy"
                      width={226}
                      height={60}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://world-lotteries.org/"
                    title="Externer Link: World Lottery Association (öffnet neues Fenster)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      alt="World Lottery Association Logo"
                      src="/assets/images/WLA-Logo-2022--white.svg"
                      className="Footer__image"
                      loading="lazy"
                      width={285}
                      height={50}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="Footer__topColumn">
            <div className="Footer__titleWrapper">
              <h3 className="Footer__title">Jugendschutz</h3>
            </div>
            <div className="Footer__box">
              <div className="Footer__infoContainer Footer__infoContainer--logoAndText">
                <div className="Footer__center">
                  <Image
                    alt=""
                    src="/assets/images/logo-ab18-white.svg"
                    className="Footer__image"
                    loading="lazy"
                    width={40}
                    height={48}
                  />
                </div>
                <span className="Footer__text Footer__text--bold">
                  Spielteilnahme ab 18 Jahren!
                </span>
              </div>
            </div>
          </div>
          <div className="Footer__topColumn">
            <div className="Footer__titleWrapper">
              <h3 className="Footer__title">Spielerschutz</h3>
            </div>
            <div className="Footer__box">
              <div>
                <span className="Footer__text--small">
                  Glücksspiel kann süchtig machen. Eine bundesweite Übersicht zu
                  Hilfsangeboten gegen Glücksspielsucht finden Sie unter{' '}
                  <a
                    className="Footer__link"
                    href="https://www.check-dein-spiel.de"
                    target="_blank"
                    title="Externer Link: https://www.check-dein-spiel.de (öffnet neues Fenster)"
                    rel="noopener noreferrer"
                  >
                    www.check-dein-spiel.de
                  </a>{' '}
                  oder{' '}
                  <a
                    className="Footer__link"
                    href="https://www.bundesweit-gegen-gluecksspielsucht.de/"
                    target="_blank"
                    title="Externer Link: https://www.bundesweit-gegen-gluecksspielsucht.de (öffnet neues Fenster)"
                    rel="noopener noreferrer"
                  >
                    www.buwei.de
                  </a>
                  .
                </span>
              </div>
            </div>
          </div>
          <div className="Footer__topColumn">
            <div className="Footer__titleWrapper">
              <h3 className="Footer__title">Aktuelle Auszeichnung</h3>
            </div>
            <div className="Footer__box">
              <div className="Footer__infoContainer Footer__infoContainer__box">
                <LinkWrapper
                  href="/ueber/tests-und-auszeichnungen/dtgv-deutscher-kunden-award-2026"
                  title='Deutscher Kunden Award 2026 für LOTTO.de: 1. Platz Kundenzufriedenheit der "Online-Lotto-Anbieter"'
                  className="Footer__center"
                  tabIndex={0}
                  rel="noopener noreferrer"
                >
                  <div className="Footer__box-content">
                    <Image
                      alt="Logo Deutscher Kunden-Award 2026"
                      src="/assets/images/dtgv-2026.webp"
                      className="Footer__image"
                      loading="lazy"
                      width={285}
                      height={135}
                    />
                  </div>
                </LinkWrapper>
              </div>
            </div>
          </div>
        </section>
        {/* Footer Section Bottom */}
        <section className="Footer__section Footer__section--bottom">
          <ul className="FooterNavBar">
            {[
              {
                path: '/impressum',
                title: 'Impressum',
              },
              {
                path: '/datenschutzerklaerung',
                title: 'Datenschutzerklärung',
              },
              {
                path: '/affiliate-programm',
                title: 'Affiliate Programm',
              },
              {
                path: '/sitemap',
                title: 'Sitemap',
              },
              {
                path: '/erklaerung-zur-barrierefreiheit',
                title: 'Barrierefreiheit',
              },
            ].map((item) => (
              <li className="FooterNavBar__column" key={item.path}>
                <LinkWrapper
                  className="FooterNavBar__link"
                  href={item.path}
                  tabIndex={0}
                >
                  {item.title}
                </LinkWrapper>
              </li>
            ))}
          </ul>

          <div className="Footer__center">
            <Logo
              lazyload={true}
              className="Footer__mainLogo"
              variant={LogoVariant.MainOnBackground}
            />
          </div>
        </section>
      </div>
    </footer>
  );
}
